"use strict";
checkList.classy.controller({
    name: 'TwoFamiliesPresentController',
    inject: ['$scope', 'ApplicationService', 'AlertService', 'PutService'],
    init: function ()
    {
        this.$.ApplicationService = this.ApplicationService;
    },
    twoFamiliesPresentComplete: function ()
    {
        this.$.alertPut([this.PutService.putThresholds()], "case80", 0);
    }
});
